import { makeStyles } from 'tss-react/mui';

const DESKTOP_APPBAR_HEIGHT = 80;
const MOBILE_APPBAR_HEIGHT = 50;

export default makeStyles()((theme) => ({
  desktopAppbarWrapper: {
    position: 'relative',
    height: DESKTOP_APPBAR_HEIGHT,
    overflow: 'visible',
  },
  desktopAppbar: {
    backgroundColor: '#262626', // Always dark - same in both modes
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    padding: 0,
    height: DESKTOP_APPBAR_HEIGHT,
    backgroundImage: 'none',
    boxShadow:
      '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
  },
  accountDropdownAnchor: {
    // Fixed so the menu stays visible when the page is scrolled; the AppBar is fixed but this
    // wrapper is in document flow, so absolute positioning would pin the menu to the top of the page.
    position: 'fixed',
    right: 0,
    top: DESKTOP_APPBAR_HEIGHT,
    width: 430,
    zIndex: theme.zIndex.appBar - 100, // Below appbar so appbar shadow sits on top
  },
  accountDropdownPanel: {
    backgroundColor: '#262626',
    boxShadow: '0px 4px 12px rgba(0,0,0,0.15)',
  },
  headerToolbarContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    flexGrow: 1,
    width: '100%',
    minWidth: 0,
  },
  headerLeftContainer: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: '0 0 auto',
  },
  desktopLogoSlot: {
    flexShrink: 0,
  },
  navLinksContainer: {
    alignItems: 'center',
    flexWrap: 'nowrap',
  },
  firstNavLink: {
    paddingLeft: theme.spacing(3),
  },
  desktopAccountHandlerContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flex: '1 1 0%',
    minWidth: 0,
    width: '100%',
    overflow: 'hidden',
  },
  desktopAccountAvatarContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexShrink: 0,
  },
  avatarMenuButton: {
    padding: 0,
    fontSize: 0,
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
      '@media (hover: none)': {
        backgroundColor: 'transparent',
      },
    },
  },
  searchBar: {
    flex: 1,
    minWidth: 0,
    maxWidth: theme.spacing(50),
    alignSelf: 'center',
    height: '33px !important',
    width: '100%',
    boxSizing: 'border-box',
  },
  mobileSearchBar: {
    borderRadius: 0,
  },
  accountHandlerFixedItem: {
    flexShrink: 0,
  },
  submitButton: {
    borderRadius: '2px',
    minWidth: '100px',
    height: '32px',
    flexShrink: 0,
    backgroundColor: theme.palette.brands.elevator_red,
    color: '#fff',
    '&:hover': {
      backgroundColor: '#FF3F3F',
    },
    [theme.breakpoints.down('md')]: {
      height: '28px',
      minWidth: 0,
      padding: theme.spacing(1),
      fontSize: theme.typography.pxToRem(12),
    },
  },
  logInButton: {
    height: '28px',
    borderColor: 'white',
    color: 'white',
    marginLeft: theme.spacing(1),
    marginRight: '4px',
    '&:hover': {
      borderColor: 'white',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
    },
  },
  hamburger: {
    color: 'white !important',
    '& *': {
      color: 'white !important',
    },
  },
  appbarAvatar: {
    marginLeft: theme.spacing(1),
  },
  submitIcon: {
    fontSize: theme.typography.pxToRem(20),
    [theme.breakpoints.down('md')]: {
      fontSize: theme.typography.pxToRem(16),
    },
  },
  loginLink: {
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
    '& a, & .MuiLink-root, & .MuiButton-root': {
      whiteSpace: 'nowrap',
    },
  },
  headerLink: {
    // Explicitly override all typography properties to prevent inheritance
    fontFamily: theme.typography.subtitle2.fontFamily,
    lineHeight: theme.typography.subtitle2.lineHeight,
    letterSpacing: theme.typography.subtitle2.letterSpacing,
    fontWeight: 700,
    textDecoration: 'none',
    color: theme.palette.common.white,
    textTransform: 'uppercase',
    fontSize: theme.typography.pxToRem(12),
    whiteSpace: 'nowrap',
    // Ensure these properties are not inherited from Typography
    fontStyle: 'normal',
    textAlign: 'left',
    '&:hover': {
      color: theme.palette.secondary.main,
      textDecoration: 'none',
    },
    '&:visited': {
      color: theme.palette.common.white,
    },
    // Target MuiLink specifically to override its defaults
    '&.MuiLink-root': {
      fontFamily: theme.typography.subtitle2.fontFamily,
      lineHeight: theme.typography.subtitle2.lineHeight,
      letterSpacing: theme.typography.subtitle2.letterSpacing,
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.common.white,
      textTransform: 'uppercase',
      textDecoration: 'none',
      '&:hover': {
        color: theme.palette.secondary.main,
        textDecoration: 'none',
      },
      '&:visited': {
        color: theme.palette.common.white,
      },
    },
    '&.MuiButton-root': {
      fontFamily: theme.typography.subtitle2.fontFamily,
      lineHeight: theme.typography.subtitle2.lineHeight,
      letterSpacing: theme.typography.subtitle2.letterSpacing,
      fontWeight: 700,
      fontSize: theme.typography.pxToRem(12),
      color: theme.palette.common.white,
      textTransform: 'uppercase',
      textDecoration: 'none',
      minWidth: 'unset',
      paddingInline: theme.spacing(0.5),
      '&:hover': {
        color: theme.palette.secondary.main,
        textDecoration: 'none',
        backgroundColor: 'transparent',
      },
      '&:visited': {
        color: theme.palette.common.white,
      },
    },
  },
  toolbar: {
    width: '100%',
    minHeight: MOBILE_APPBAR_HEIGHT,
    boxSizing: 'border-box',
  },
  mobileUserMenuIconButton: {
    padding: 0,
  },
  mobileLoginButton: {
    textTransform: 'uppercase',
    fontSize: theme.typography.pxToRem(11),
    fontWeight: 700,
    minWidth: 'auto',
    paddingInline: theme.spacing(1.5),
    paddingBlock: theme.spacing(0.5),
    borderColor: 'rgba(255, 255, 255, 0.5)',
    color: theme.palette.common.white,
    '&:hover': {
      borderColor: theme.palette.common.white,
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },

  // MOBILE ONLY
  mobileAppbarWrapper: {
    position: 'relative',
    height: MOBILE_APPBAR_HEIGHT,
    overflow: 'visible',
  },
  root: {
    position: 'fixed',
    flexGrow: 1,
    zIndex: 3,
    width: '100%',
  },
  mobileAppBar: {
    backgroundColor: '#262626', // Always dark - same as desktop appbar in both modes
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    padding: 0,
    height: MOBILE_APPBAR_HEIGHT,
    backgroundImage: 'none',
    boxShadow:
      '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
  },
  mobileLogoContainer: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    marginLeft: theme.spacing(2),
  },
  collapseMenuContainer: {
    position: 'fixed',
    top: MOBILE_APPBAR_HEIGHT,
    left: 0,
    width: '100%',
    zIndex: 3,
  },
  listMenuContainer: {
    width: '100%',
    color: 'red',
  },
  list: {
    padding: 0,
    color: 'white',
  },
  userOptionsList: {
    padding: 0,
    paddingTop: theme.spacing(1),
  },
  listItem: {
    color: 'white',
    textTransform: 'uppercase',
    '&:hover': {
      color: 'red',
      backgroundColor: 'transparent',
      cursor: 'pointer',
    },
  },
  listItemHighEmphasis: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.custom.grey.dark, // Always #333333 in both modes
    textTransform: 'uppercase',
    cursor: 'pointer',
    '&:hover': {
      color: theme.palette.brands.elevator_red,
      cursor: 'pointer',
    },
  },
  listDivider: {
    listStyle: 'none',
  },
  mobileList: {
    paddingLeft: theme.spacing(2),
  },
  lastItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
  },
  disabledHover: {
    '&:hover': {
      color: 'white',
      backgroundColor: 'transparent',
    },
  },
  listIcon: {
    color: theme.palette.getRgba(theme.palette.common.white, 0.25),
    paddingLeft: theme.spacing(1),
  },
  loginRoot: {
    paddingTop: 0,
  },
  profileListItem: {
    paddingTop: theme.spacing(2),
  },
  avatarDrawer: {
    width: '280px',
    backgroundColor: '#333333', // Always dark - same as mobile menu in both modes
  },
  emailText: {
    color: 'rgba(255, 255, 255, 0.7)', // Light color for dark background
  },
}));
